import type { DocumentTemplate } from "@/types/documents";

export const BLANK_DOCUMENT_TEMPLATE: DocumentTemplate = {
  id: "blank-document",
  name: "Blank Document",
  companyId: null,
  body: {
    type: "doc",
    content: [
      {
        type: "paragraph",
        attrs: { textAlign: "left" },
      },
    ],
  },
};

export const documentTemplates: DocumentTemplate[] = [
  BLANK_DOCUMENT_TEMPLATE,
  {
    id: "snowball-pir-template",
    name: "Snowball PIR Template",
    companyId: "snowball",
    body: {
      type: "doc",
      content: [
        {
          type: "heading",
          attrs: { textAlign: "left", level: 1 },
          content: [{ type: "text", text: "[Logo Placeholder]" }],
        },
        { type: "paragraph", attrs: { textAlign: "left" } },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: "" },
                },
              ],
              text: "Investment Rationale",
            },
          ],
        },
        { type: "paragraph", attrs: { textAlign: "left" } },
        { type: "paragraph", attrs: { textAlign: "left" } },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: null },
                },
              ],
              text: "Underlying Investments",
            },
          ],
        },
        { type: "paragraph", attrs: { textAlign: "left" } },
        { type: "paragraph", attrs: { textAlign: "left" } },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: "" },
                },
              ],
              text: "Impact Story",
            },
          ],
        },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [{ type: "text", text: "​" }],
        },
        { type: "paragraph", attrs: { textAlign: "left" } },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: null },
                },
              ],
              text: "Fund Details",
            },
          ],
        },
        {
          type: "bulletList",
          content: [
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Name:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Asset Class:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Impact class:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Snowball Theme:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Fund Strategy:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Geography:" }],
                },
              ],
            },
          ],
        },
        {
          type: "paragraph",
          attrs: { textAlign: "left" },
          content: [{ type: "text", text: "​" }],
        },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: null },
                },
              ],
              text: "Fund Information",
            },
          ],
        },
        {
          type: "bulletList",
          content: [
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Fund Size:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Initial Inv. Date:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "B Corp:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Public / Private:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Liquidity:" }],
                },
                { type: "paragraph", attrs: { textAlign: "left" } },
              ],
            },
          ],
        },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: null },
                },
              ],
              text: "Investment Details",
            },
          ],
        },
        {
          type: "bulletList",
          content: [
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Contact:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Investment team lead:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Structure:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Target Return:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Term / Maturity:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Fees:" }],
                },
              ],
            },
            {
              type: "listItem",
              content: [
                {
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{ type: "text", text: "Bullseye Score:" }],
                },
              ],
            },
          ],
        },
        { type: "paragraph", attrs: { textAlign: "left" } },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: "" },
                },
              ],
              text: "Key Financials",
            },
          ],
        },
        { type: "paragraph", attrs: { textAlign: "left" } },
        {
          type: "heading",
          attrs: { textAlign: "left", level: 2 },
          content: [
            {
              type: "text",
              marks: [
                {
                  type: "textStyle",
                  attrs: { class: "text-lg leading-6", color: "" },
                },
              ],
              text: "KPIs",
            },
          ],
        },
      ],
    },
  },
  {
    id: "saltus-meeting-notes",
    name: "Saltus Meeting Notes",
    companyId: "saltus",
    body: {
      type: "doc",
      content: [
        {
          type: "heading",
          attrs: { level: 1, class: "font-serif" },
          content: [{ type: "text", text: "Meeting Date" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: new Date().toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              }),
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Saltus Attendees" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add Saltus attendees]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Fund Attendees" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add fund attendees]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Executive Summary" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add executive summary]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Parent" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add parent details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Product" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add product details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "People" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add people details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Process" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add process details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Philosophy" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add philosophy details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Positions" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add positions details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Portfolio Construction" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add portfolio construction details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Macro Outlook" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add macro outlook details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
        {
          type: "heading",
          attrs: { level: 2, class: "font-serif" },
          content: [{ type: "text", text: "Performance" }],
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "[Add performance details]",
              marks: [{ type: "italic" }],
            },
          ],
        },
        {
          type: "paragraph",
          content: [{ type: "text", text: "\u200B" }],
        },
      ],
    },
  },
];
